// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38745","right":"styles_right__2Gt0e"};